(function () {
  function initCarousel(scene) {
    var media = scene.querySelector('[data-scenario-carousel]');
    if (!media || media.dataset.scenarioCarouselReady === 'true') return;
    var track = media.querySelector('[data-scenario-slide-track]');
    var slides = Array.prototype.slice.call(media.querySelectorAll('[data-scenario-slide]'));
    var indicators = Array.prototype.slice.call(media.querySelectorAll('[data-scenario-indicator]'));
    if (!track || slides.length < 2) return;

    media.dataset.scenarioCarouselReady = 'true';
    var activeIndex = 0;
    slides.forEach(function (slide) { slide.hidden = false; });
    function showImage(index) {
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + (activeIndex * 100) + '%, 0, 0)';
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      indicators.forEach(function (indicator, indicatorIndex) {
        var active = indicatorIndex === activeIndex;
        indicator.classList.toggle('is-active', active);
        indicator.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
    showImage(0);
    track.classList.add('is-ready');

    indicators.forEach(function (indicator, indicatorIndex) {
      indicator.addEventListener('click', function () { showImage(indicatorIndex); });
    });

    media.classList.add('is-draggable');
    media.addEventListener('dragstart', function (event) { event.preventDefault(); });
    var mousePointerId = null;
    var mouseStartX = 0;
    var mouseDragStarted = false;

    function resetMouseDrag() {
      mousePointerId = null;
      mouseDragStarted = false;
      media.classList.remove('is-dragging');
      track.classList.remove('is-dragging');
    }

    media.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || mousePointerId !== null || !window.matchMedia('(min-width: 768px)').matches || event.target.closest('[data-scenario-indicator]')) return;
      mousePointerId = event.pointerId;
      mouseStartX = event.clientX;
      mouseDragStarted = false;
      media.setPointerCapture(event.pointerId);
    });

    media.addEventListener('pointermove', function (event) {
      if (event.pointerId !== mousePointerId) return;
      var distanceX = event.clientX - mouseStartX;
      if (!mouseDragStarted && Math.abs(distanceX) < 5) return;
      mouseDragStarted = true;
      media.classList.add('is-dragging');
      track.classList.add('is-dragging');
      if ((activeIndex === 0 && distanceX > 0) || (activeIndex === slides.length - 1 && distanceX < 0)) distanceX *= .2;
      track.style.transform = 'translate3d(calc(-' + (activeIndex * 100) + '% ' + (distanceX < 0 ? '- ' : '+ ') + Math.abs(distanceX) + 'px), 0, 0)';
      event.preventDefault();
    });

    media.addEventListener('pointerup', function (event) {
      if (event.pointerId !== mousePointerId) return;
      var distanceX = event.clientX - mouseStartX;
      var didDrag = mouseDragStarted;
      resetMouseDrag();
      if (media.hasPointerCapture(event.pointerId)) media.releasePointerCapture(event.pointerId);
      if (!didDrag) return;
      var threshold = Math.min(80, Math.max(40, media.clientWidth * .15));
      var nextIndex = activeIndex;
      if (Math.abs(distanceX) >= threshold) nextIndex += distanceX < 0 ? 1 : -1;
      showImage(Math.max(0, Math.min(slides.length - 1, nextIndex)));
    });

    function cancelMouseDrag(event) {
      if (event.pointerId !== mousePointerId) return;
      resetMouseDrag();
      showImage(activeIndex);
    }
    media.addEventListener('pointercancel', cancelMouseDrag);
    media.addEventListener('lostpointercapture', cancelMouseDrag);

    var touchStartX = null;
    var touchStartY = null;
    media.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    media.addEventListener('touchend', function (event) {
      if (touchStartX === null || !event.changedTouches.length) return;
      var distanceX = event.changedTouches[0].clientX - touchStartX;
      var distanceY = event.changedTouches[0].clientY - touchStartY;
      touchStartX = null;
      touchStartY = null;
      if (Math.abs(distanceX) > 40 && Math.abs(distanceX) > Math.abs(distanceY)) {
        showImage(activeIndex + (distanceX < 0 ? 1 : -1));
      }
    }, { passive: true });
    media.addEventListener('touchcancel', function () {
      touchStartX = null;
      touchStartY = null;
    }, { passive: true });
  }

  function activate(section, index, moveFocus) {
    var scenes = Array.prototype.slice.call(section.querySelectorAll('[data-scenario-scene]'));
    if (!scenes.length) return;

    var activeIndex = Math.max(0, Math.min(index, scenes.length - 1));
    scenes.forEach(function (scene, sceneIndex) {
      var active = sceneIndex === activeIndex;
      var tab = scene.scenarioBundleTab || scene.querySelector('.scenario-bundle__tab');
      var panel = scene.querySelector('.scenario-bundle__panel');
      scene.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
      panel.hidden = !active;
      if (active && moveFocus) {
        tab.focus();
        tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    });
  }

  function init(section) {
    if (!section) return;
    if (section.dataset.scenarioBundleReady === 'true') return;
    var scenes = Array.prototype.slice.call(section.querySelectorAll('[data-scenario-scene]'));
    if (!scenes.length) return;

    section.dataset.scenarioBundleReady = 'true';
    var tabList = section.querySelector('.scenario-bundle__tabs');
    var tabRail = document.createElement('div');
    tabRail.className = 'scenario-bundle__tab-rail';
    scenes.forEach(function (scene) {
      scene.scenarioBundleTab = scene.querySelector('.scenario-bundle__tab');
      tabRail.appendChild(scene.scenarioBundleTab);
    });
    tabList.insertBefore(tabRail, tabList.firstChild);
    tabList.classList.add('is-enhanced');
    scenes.forEach(function (scene, index) {
      initCarousel(scene);
      var tab = scene.scenarioBundleTab;
      tab.addEventListener('click', function () { activate(section, index, false); });
      tab.addEventListener('keydown', function (event) {
        var nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % scenes.length;
        else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + scenes.length) % scenes.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = scenes.length - 1;
        else return;
        event.preventDefault();
        activate(section, nextIndex, true);
      });
    });
    activate(section, 0, false);
  }

  function initAll(root) {
    if (root.matches && root.matches('[data-scenario-bundle]')) init(root);
    root.querySelectorAll('[data-scenario-bundle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var scene = event.target.closest('[data-scenario-scene]');
    if (!scene) return;
    var section = scene.closest('[data-scenario-bundle]');
    if (!section) return;
    init(section);
    var scenes = Array.prototype.slice.call(section.querySelectorAll('[data-scenario-scene]'));
    activate(section, scenes.indexOf(scene), false);
  });
})();
